export const textTypeEnum = Object.freeze({
  uniqueValue: 'uniqueValue',
  empty: "empty",
  notEmpty: "notEmpty",
  textContains: "textContains",
  textDoesNotContain: "textDoesNotContain",
  textStartsWith: "textStartsWith",
  textEndsWith: "textEndsWith",
  textIsExactly: "textIsExactly",
});

export const numberTypeEnum = Object.freeze({
    uniqueValue: 'uniqueValue',
    empty: "empty",
    notEmpty: "notEmpty",
    moreThan: "moreThan",
    moreThanOrEqualTo: "moreThanOrEqualTo",
    lessThan: "lessThan",
    lessThanOrEqualTo: "lessThanOrEqualTo",
    equal: "equal",
    notEqual: "notEqual",
    isBetween: "isBetween",
    isNotBetween: "isNotBetween",
  });

export const dateTypeEnum = Object.freeze({
    uniqueValue: 'uniqueValue',
    empty: "empty",
    notEmpty: "notEmpty",
    dateIs: "dateIs",
    dateIsBefore: "dateIsBefore",
    dateIsAfter: "dateIsAfter",
    isBetween: "isBetween",
    isNotBetween: "isNotBetween",
  });

export const colorSchemeType = Object.freeze({
  conditionalColor: "conditional_color",
  gradient: "gradient",
});

export const columnDataType = Object.freeze({
    text: "text",
    date: "date",
    number: "number",
});

export const conditionTabId = Object.freeze({
  basic: "basic",
  advance: "advance",
});